module.exports = __webpack_public_path__ + "static/media/order.761fb351.gif";